import React from 'react';

import Container from './Container';
import Status from './Status';
import Date from './Date';
import Creator from './Creator';

export default ({ status }) => (
  <Container>
    <Status>{status.human_status}</Status>
    <Creator>{status.creator_name}</Creator>
    <Date>{status.created_at}</Date>
  </Container>
);
